/* tslint:disable */

declare var Object: any;
export interface ActivityImagesInterface {
  "activityId": string;
  "images_name": string;
  "id"?: number;
}

export class ActivityImages implements ActivityImagesInterface {
  "activityId": string;
  "images_name": string;
  "id": number;
  constructor(data?: ActivityImagesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ActivityImages`.
   */
  public static getModelName() {
    return "ActivityImages";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ActivityImages for dynamic purposes.
  **/
  public static factory(data: ActivityImagesInterface): ActivityImages{
    return new ActivityImages(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ActivityImages',
      plural: 'ActivityImages',
      path: 'ActivityImages',
      properties: {
        "activityId": {
          name: 'activityId',
          type: 'string'
        },
        "images_name": {
          name: 'images_name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ActivityImages.ts